export enum BannerAnnouncementStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  EXPIRED = 'expired',
}

export interface BannerAnnouncementItem {
  id: string;
  title: string;
  description: string;
  cta_label?: string;
  cta_url?: string;
  start_date: string;
  end_date: string;
  status: BannerAnnouncementStatus;
}

export interface BannerAnnouncementResponse {
  list: BannerAnnouncementItem[];
}
